module.exports = __webpack_public_path__ + "kz.130a3907.svg";